import React from "react";
import "../../assets/generalTrade.css";

const GeneralTradeTeam: React.FC = () => {
  return (
    <main className="gt-page">
      <section className="gt-page-banner">
        <div className="gt-container">
          <span className="gt-eyebrow">Our Team</span>
          <h1>People behind Lyra Zone General Trading</h1>
        </div>
      </section>

      <section className="gt-content-section">
        <div className="gt-container">
          <div className="gt-coming-card">
            <h2>Team Profiles</h2>
            <p>
              This page is ready for the General Trade team profiles. Names,
              designations, photographs and profiles can be connected here when
              the final team content is available.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GeneralTradeTeam;
